import apiService from './api';

export interface ProfileListingModuleData {
  project_context: {
    brand: string;
    description: string;
    tone: string;
    audience: string;
    website_url: string;
    keywords: string[];
    products: string[];
    services: string[];
    address?: string;
    phone?: string;
    email?: string;
    operating_hours?: string;
    primary_business?: string;
  };
  platforms: {
    platform_name: string;
    platform_url: string;
    da_score: number;
  }[];
  is_new_website?: boolean;
}

export interface ProfileListingGenerationRequest {
  platform_names: string[];
}

export interface ProfileListingGenerationResponse {
  generation_id: string;
  status: string;
}

export interface ProfileListingItem {
  id: string;
  generation_id: string;
  platform_name: string;
  platform_url: string;
  status: string;
  business_name?: string;
  description?: string;
  address?: string;
  phone?: string;
  email?: string;
  website_url?: string;
  category?: string;
  operating_hours?: string;
  published_platforms?: string[];
  is_user_modified: boolean;
  created_at: string;
}

export interface ProfileListingEditRequest {
  business_name?: string;
  description?: string;
  address?: string;
  phone?: string;
  email?: string;
  website_url?: string;
  category?: string;
  operating_hours?: string;
  published_platforms?: string[];
}

export async function getModuleData(): Promise<ProfileListingModuleData> {
  const res = await apiService.request<ProfileListingModuleData>(
    '/profile-listing/module-data',
    { method: 'GET' }
  );
  return res;
}

export async function generateListings(payload: ProfileListingGenerationRequest): Promise<ProfileListingGenerationResponse> {
  const res = await apiService.request<ProfileListingGenerationResponse>(
    '/profile-listing/generate-content',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
  return res;
}

export async function getGeneratedListings(generationId: string): Promise<ProfileListingItem[]> {
  const res = await apiService.request<ProfileListingItem[]>(
    `/profile-listing/generated/${encodeURIComponent(generationId)}`,
    { method: 'GET' }
  );
  return res;
}

export async function getAllListings(): Promise<ProfileListingItem[]> {
  const res = await apiService.request<ProfileListingItem[]>(
    '/profile-listing/listings',
    { method: 'GET' }
  );
  return res;
}

export async function updateListing(listingId: string, payload: ProfileListingEditRequest): Promise<ProfileListingItem> {
  const res = await apiService.request<ProfileListingItem>(
    `/profile-listing/listings/${encodeURIComponent(listingId)}`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    }
  );
  return res;
}

export async function initiateScan(projectId: string, module: string): Promise<{ scan_id: string; message: string }> {
  return await apiService.request<{ scan_id: string; message: string }>(
    '/seo/implementation/scan',
    {
      method: 'POST',
      body: JSON.stringify({ project_id: projectId, module }),
    }
  );
}

export async function getScanStatus(scanId: string): Promise<{ status: string; result?: any }> {
  return await apiService.request<{ status: string; result?: any }>(
    `/seo/implementation/scan/${encodeURIComponent(scanId)}`,
    { method: 'GET' }
  );
}

